export default [
  {
    path: '/admin/payroll-cycle-dates',
    name: 'payroll-cycle-date',
    meta: { requiresAuth: true },
    component: () => import('@/pages/payroll/payroll-cycle-date/index.vue')
  }
]
